import {
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";

import { Link } from "react-router-dom";
import { getBadgeClassNameByStatus } from "../../../helpers/colors";
import { RideStatus, RideStatusLabels } from "../../../helpers/enums";
import { formatDateString, paymentMethodHelper } from "../../../helpers/general";
import { format } from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPercent } from "@fortawesome/free-solid-svg-icons";
import { ProfilePictureAvatar } from "../../taxi/Profile_picture_avatar";

const ONE_KILOMETER = 1000;
function metersToKilometers(meters: number): number {
  return meters < ONE_KILOMETER ? meters : meters / ONE_KILOMETER;
}

interface Props {
  rides: Ride[];
}

export default function SimpleUserRidersTable({ rides }: Props) {
  return (
    <CTable responsive>
      <CTableHead>
        <CTableRow>
          <CTableHeaderCell scope="col" className="text-sm">
            <div className="d-flex align-items-center justify-content-between">
              Référence du trajet
            </div>
          </CTableHeaderCell>
          <CTableHeaderCell scope="col" className="text-sm">
            <div className="d-flex align-items-center justify-content-between">
              Date de création
            </div>
          </CTableHeaderCell>
          <CTableHeaderCell scope="col" className="text-sm">
            <div className="d-flex align-items-center justify-content-between">
              Chauffeur
            </div>
          </CTableHeaderCell>

          <CTableHeaderCell scope="col" className="text-sm">
            <div className="d-flex align-items-center justify-content-between">
              Localisation et Destination
            </div>
          </CTableHeaderCell>

          <CTableHeaderCell scope="col" className="text-sm">
            <div className="d-flex align-items-center justify-content-between">
              Statut
            </div>
          </CTableHeaderCell>
          <CTableHeaderCell scope="col" className="text-sm ">
            <div className="d-flex align-items-center justify-content-between">
              Moyen de paiement
            </div>
          </CTableHeaderCell>
          {/* Distance */}
          <CTableHeaderCell scope="col" className="text-sm">
            <div className="d-flex align-items-center justify-content-between">
              Distance
            </div>
          </CTableHeaderCell>
          {/* Durée estimée (min) */}
          <CTableHeaderCell scope="col" className="text-sm">
            <div className="d-flex align-items-center justify-content-between">
              Durée estimée (min)
            </div>
          </CTableHeaderCell>
          {/* Frais originaux (MAD) */}
          <CTableHeaderCell scope="col" className="text-sm">
            <div className="d-flex align-items-center justify-content-between">
              Frais originaux (MAD)
            </div>
          </CTableHeaderCell>
          {/* Montant du coupon (MAD) */}
          <CTableHeaderCell scope="col" className="text-sm">
            <div className="d-flex align-items-center justify-content-between">
              Montant du coupon (MAD)
            </div>
          </CTableHeaderCell>
          {/* Montant payé (MAD) */}
          <CTableHeaderCell scope="col" className="text-sm">
            <div className="d-flex align-items-center justify-content-between">
              Montant payé (MAD)
            </div>
          </CTableHeaderCell>
        </CTableRow>
      </CTableHead>
      <CTableBody>
        {rides.map((ride) => {
          const discountAmount = ride?.priceCalculation?.coupon?.isCouponApplied
            ? +ride?.originalFare -
            ride?.priceCalculation?.coupon?.fareAfterCoupon
            : 0;

          return (
            <CTableRow key={ride.id}>
              {/* Référence */}
              <CTableDataCell className="p-3 text-sm">
                <Link to={`/rides/${ride.id}/ridedetails`} state={{ ride }}>
                  {ride.reference || "N/A"}
                </Link>
              </CTableDataCell>
              {/* Date */}
              {/* <CTableDataCell className="px-3 text-sm">
                {formatDateString(ride.createdAt)}{" - "}
                {format(new Date(ride.createdAt), "HH:mm")}
              </CTableDataCell> */}
              <CTableDataCell>
                <div className="p-2 text-sm">
                  {formatDateString(ride.createdAt)} -{" "}
                  {format(new Date(ride.createdAt), "HH:mm")}
                </div>
                {ride?.priceCalculation?.coupon?.isCouponApplied && (
                  <div
                    className=" d-flex align-items-center justify-content-center "
                    style={{
                      top: "5px",
                      left: "10px",
                      background: "linear-gradient(45deg, #FF7722, #FFB800)",
                      padding: "2px 4px",
                      margin: "0px 25px",
                      borderRadius: "30px",
                      fontSize: "1rem",
                      color: "white",
                    }}
                  >
                    -{ride?.priceCalculation?.coupon?.couponPercentage}{" "}
                    <FontAwesomeIcon icon={faPercent} className="me-2" />
                  </div>
                )}
              </CTableDataCell>

              {/* Chauffeur */}
              <CTableDataCell className="px-3 text-sm">
                {ride?.driver && (
                  <>
                    <ProfilePictureAvatar
                      profilePicture={ride?.driver?.profilePicture}
                      fullName={ride?.driver?.fullName}
                      isOnline={ride?.driver?.driverProfile?.isOnline}
                    />
                    <Link
                      to={`/drivers/${ride.driver?.id}`}
                      className="fw-bold m-0 text-capitalize"
                    >
                      {ride.driver?.fullName || "Inconnu"}
                    </Link>
                  </>
                )}
              </CTableDataCell>

              {/* Localisation et Destination */}
              <CTableDataCell className="px-3 text-sm">
                <span className="fw-bold">De:</span> {ride.pickupLocationName}{" "}
                <br />
                <span className="fw-bold">À:</span>{" "}
                {ride.destinationLocationName}
              </CTableDataCell>

              {/* Statut */}
              <CTableDataCell className="px-3 text-sm">
                <span
                  className={
                    ride.status === RideStatus.WAITING_PICKUP
                      ? "badge-primary"
                      : getBadgeClassNameByStatus(ride.status)
                  }
                >
                  {RideStatusLabels[
                    ride.status as keyof typeof RideStatusLabels
                  ] || "Statut inconnu"}
                </span>
              </CTableDataCell>
              {/* Moyen de paiement */}
              <CTableDataCell className="p-3 text-sm">
                {paymentMethodHelper(ride?.paymentMethod)}

              </CTableDataCell>
              <CTableDataCell className="p-3 text-sm">
                {metersToKilometers(ride.distance).toFixed(2)}{" "}
                {ride.distance < ONE_KILOMETER ? "m" : "Km"}
              </CTableDataCell>
              <CTableDataCell className="p-3 text-sm">
                {ride.estimatedDuration
                  ? Math.floor(ride.estimatedDuration / 60)
                  : ""}
              </CTableDataCell>
              <CTableDataCell className="p-3 text-sm">
                {ride.originalFare}
              </CTableDataCell>
              <CTableDataCell className="p-3 text-sm">
                {discountAmount}
              </CTableDataCell>
              <CTableDataCell className="p-3 text-sm">
                {ride?.fare}
              </CTableDataCell>
            </CTableRow>
          );
        })}
      </CTableBody>
    </CTable>
  );
}
